import { ComponentType } from 'react';
import { ServiceChartCard, ServiceTableCard } from './ServiceCards';
import { MatchChartCard, MatchTableCard } from './MatchCards';
import { EndReasonTypeChartCard, EndReasonTypeTableCard } from './EndReasonTypeCards';
import { FafsaChartCard, FafsaTableCard } from './FafsaDashboard';
import { GenderChartCard, GenderTableCard } from './GenderDashboard';
import { NotificationsCard } from './NotificationsDashboard';
import { TotalStudentsCard } from './StudentDashboard';
import { SchoolEnrollmentCard } from './SchoolEnrollmentDashboard';
import { ParticipantsChartCard, ParticipantsTableCard } from './ParticipantsCards';
import { EligibilityChartCard, EligibilityTableCard } from './EligibilityCards';
import { LkDashboardCardId } from './types';
import { RaceTableCard } from './RaceDashboard/RaceTableCard';
import { RaceChartCard } from './RaceDashboard/RaceChartCard';
import { EthnicityTableCard } from './EthnicityDashboard/EthnicityTableCard';
import { EthnicityChartCard } from './EthnicityDashboard/EthnicityChartCard';
import { IEPTableCard } from './IEPDashboard/IEPTableCard';
import { IEPChartCard } from './IEPDashboard/IEPChartCard';
import { LEPTableCard } from './LEPDashboard/LEPTableCard';
import { LEPChartCard } from './LEPDashboard/LEPChartCard';
import { GPAChartCard, GPATableCard } from './GPADashboard';
import { StudentServiceChartCard, StudentServiceTableCard } from './StudentServiceDashboard';
import { GradeLevelTableCard } from './GradeLevelDashboard';

type DashboardCardComponent = ComponentType<{}>;

export const DASHBOARD_CARD_REGISTRY: Record<number, DashboardCardComponent> = {
  [LkDashboardCardId.ServiceChart]: ServiceChartCard,
  [LkDashboardCardId.ServiceTable]: ServiceTableCard,
  [LkDashboardCardId.MatchChart]: MatchChartCard,
  [LkDashboardCardId.MatchTable]: MatchTableCard,
  [LkDashboardCardId.Notifications]: NotificationsCard,
  [LkDashboardCardId.TotalStudents]: TotalStudentsCard,
  [LkDashboardCardId.SchoolEnrollment]: SchoolEnrollmentCard,
  [LkDashboardCardId.FafsaChart]: FafsaChartCard,
  [LkDashboardCardId.FafsaTable]: FafsaTableCard,
  [LkDashboardCardId.EndReasonTypeTable]: EndReasonTypeTableCard,
  [LkDashboardCardId.EndReasonTypeChart]: EndReasonTypeChartCard,
  [LkDashboardCardId.ParticipantsChart]: ParticipantsChartCard,
  [LkDashboardCardId.ParticipantsTable]: ParticipantsTableCard,
  [LkDashboardCardId.GenderChart]: GenderChartCard,
  [LkDashboardCardId.GenderTable]: GenderTableCard,
  [LkDashboardCardId.EligibilityChart]: EligibilityChartCard,
  [LkDashboardCardId.EligibilityTable]: EligibilityTableCard,
  [LkDashboardCardId.RaceChart]: RaceChartCard,
  [LkDashboardCardId.RaceTable]: RaceTableCard,
  [LkDashboardCardId.EthnicityChart]: EthnicityChartCard,
  [LkDashboardCardId.EthnicityTable]: EthnicityTableCard,
  [LkDashboardCardId.IEPChart]: IEPChartCard,
  [LkDashboardCardId.IEPTable]: IEPTableCard,
  [LkDashboardCardId.LEPChart]: LEPChartCard,
  [LkDashboardCardId.LEPTable]: LEPTableCard,
  [LkDashboardCardId.GradeLevelTable]: GradeLevelTableCard,
  [LkDashboardCardId.StudentServiceChart]: StudentServiceChartCard,
  [LkDashboardCardId.StudentServiceTable]: StudentServiceTableCard,
  [LkDashboardCardId.GPAChart]: GPAChartCard,
  [LkDashboardCardId.GPATable]: GPATableCard,
};
